export const AUTH_REQUEST_STATES = {
    NOT_SENT: 'not_sent',
    PENDING: 'pending',
    SENT: 'sent',
    FAILED: 'failed',
};
